export const iconFontAwesomeMedicalHealthCannabis = (
	<i className="fa-solid fa-cannabis"></i>
);
